import {
    // GET_CONSIGNMENT_ADD_DETAILS,
    // GET_CONSIGNMENT_ADD_DETAILS_SUCCESS,
    // GET_CONSIGNMENT_ADD_DETAILS_FAILURE,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_FAILURE,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST,
    CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST_SUCCESS,
    CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST_FAILURE,
    CONSIGNMENT_ADD_RESET_PO_ATTACHMENT,
    CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW,
    CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW_SUCCESS,
    CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW_FAILURE,
    STORE_CONSIGNMENT_ADD_REFERENCE,
    RESET_CONSIGNMENT_ADD_REFERENCE,
    GET_CONSIGNMENT_ADD_MYCASEREF_SUCCESS,
    GET_CONSIGNMENT_ADD_MYCASEREF_FAILURE,
    GET_CONSIGNMENT_ADD_MYCASEREF,
} from '../actions/actionTypes';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    consignmentAddDetails: {
        myCaseRef: '',
        myCaseRefValue: '',
    },
    myCaseRefId: null,
    myCaseResourceType: null,
    isdeletionDone: false,
    isUsageAttachmentUploaded: false,
    poTissueImageDetails: '',
    poNonTissueImageDetails: '',
    poImagePreviewLoader: false,
    poImagePreviewDetails: null,
    poImageUploadLoader: false,
    poImageDeleteLoader: false,
};

const consignmentAddDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        // case GET_CONSIGNMENT_ADD_DETAILS:
        //     return {
        //         ...state,
        //         ...initialState,
        //         // myCaseRef: action.myCaseRef,
        //     };
        // case GET_CONSIGNMENT_ADD_DETAILS_SUCCESS:
        //     return {
        //         ...state,
        //         consignmentAddDetails: {
        //             myCaseRef: action.myCaseRef,
        //         },
        //     };
        case GET_CONSIGNMENT_ADD_MYCASEREF:
            return {
                ...state,
                ...initialState,
            };
        case GET_CONSIGNMENT_ADD_MYCASEREF_SUCCESS:
            return {
                ...state,
                consignmentAddDetails: {
                    myCaseRef: action.myCaseRef,
                },
            };
        case GET_CONSIGNMENT_ADD_MYCASEREF_FAILURE:
            return {
                ...state,
                consignmentAddDetails: {
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        // case GET_CONSIGNMENT_ADD_DETAILS_FAILURE:
        //     return {
        //         ...state,
        // consignmentAddDetails: {
        //     statusCode: action.statusCode,
        //     statusMessage: action.statusMessage,
        // },
        //     };
        case CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD:
            return {
                ...state,
                poImageUploadLoader: true,
            };
        case CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE:
            return {
                ...state,
                poNonTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE:
            return {
                ...state,
                poTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_FAILURE:
            return {
                ...state,
                isUsageAttachmentUploaded: false,
                poImageUploadLoader: false,
            };
        case CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST:
            return {
                ...state,
                poImageDeleteLoader: true,
            };
        case CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                poTissueImageDetails: action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poTissueImageDetails,
                poNonTissueImageDetails: !action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poNonTissueImageDetails,
                poImageDeleteLoader: false,
            };
        case CONSIGNMENT_ADD_RESET_PO_ATTACHMENT:
            return {
                ...state,
                poTissueImageDetails: '',
                poNonTissueImageDetails: '',
            };
        case CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                isdeletionDone: false,
                poImageDeleteLoader: false,
            };
        case CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW:
            return {
                ...state,
                poImagePreviewLoader: true,
            };
        case CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW_SUCCESS:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: action.payload,
            };
        case CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW_FAILURE:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: null,
            };
        case STORE_CONSIGNMENT_ADD_REFERENCE:
            return {
                ...state,
                consignmentAddDetails: {
                    ...state.consignmentAddDetails,
                    myCaseRefValue: action.payload,
                },
            };
        case RESET_CONSIGNMENT_ADD_REFERENCE:
            return {
                ...state,
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentAddDetailsKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    consignmentAddDetailsReducer
);
